export var compKey = 'libby-layout';
//# sourceMappingURL=key.js.map